<template>
  <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="CRON">
          <v-card-component>
        <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
          <v-card-title>
            <v-spacer></v-spacer>
          </v-card-title>
           <v-card-actions>
          <v-btn color="accent" @click="getCronList()" elevation="1" absolute left top>
            <v-icon left>mdi-refresh</v-icon>Refresh
          </v-btn>
      </v-card-actions>
          <v-text-field
            :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width:350px;"
          />

        </v-card-text>
        <v-divider class="my-0 py-0"></v-divider>
        <v-data-table :headers="headers" :items="tableData" :search="search" disable-pagination hide-default-footer>
      <template v-slot:item.startTime="{ item }">
    <span>{{moment(item.startTime  ).format('LLL') }}</span>
  </template>
   <template v-slot:item.endTime="{ item }">
    <span>{{item.endTime?moment(item.endTime).format('LLL') :'-'}}</span>
  </template>
      <template  v-slot:item.actions="{ item }">
        <div>
           <v-btn @click="startCron(item)" class="px-2 ml-1 white--text ma-1" v-if="item.status===status.completed || item.status===status.notStarted|| item.status===status.error" color="success" min-width="0" small>
                <v-icon small> mdi-restart</v-icon>
                Start Cron
              </v-btn>
              <v-btn @click="completeCron(item)" class="px-2 ml-1 white--text ma-1" v-if="item.status===status.inProgress" color="error" min-width="0" small>
                <v-icon small> mdi-restart</v-icon>
                Complete
              </v-btn>
          <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="item.isActive" @click.prevent="activateDeactivateCron(item)">
              <v-icon small> mdi-delete</v-icon>
            </v-btn>
            <v-btn class="px-2 ml-1 ma-1" color="info" min-width="0" small @click.prevent="activateDeactivateCron(item)" v-if="!item.isActive">
              <v-icon small> mdi-restore</v-icon>
            </v-btn>
        </div>
          </template>
          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>

      </v-card-component>
          </material-card>
       </v-container>
</template>
<script>
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
import moment from 'moment'
export default {
  components: { VCardComponent, MaterialCard },

  data () {
    return {
      search: '',
      moment: moment,
      status: constants.cron.status,
      tableData: [],
      headers: [
        { text: 'Name', value: 'name' },
        // Remove the only time column
        // { text: 'Time', value: 'cronTime' },

        { text: 'Start time', value: 'startTime', datatype: 'Date' },
        { text: 'End time', value: 'endTime', datatype: 'Time' },
        { text: 'status', value: 'status' },
        { text: 'Action', value: 'actions', align: 'center', sortable: false },
        { text: 'ErrorLog', value: 'error' }
      ]
    }
  },
  async created () {
    await this.getCronList()
  },
  methods: {
    getCronList: async function () {
      try {
        console.log('this.status', this.status)
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/cron`)

        this.tableData = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    startCron: async function (item) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.get(`${constants.API_URL}/api/cron/start/${item.id}`)
        this.loadingComponent.close()
        await this.getCronList()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    activateDeactivateCron: async function (item) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.get(`${constants.API_URL}/api/cron/active-de-active/${item.id}`)
        this.loadingComponent.close()
        await this.getCronList()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    completeCron: async function (item) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.get(`${constants.API_URL}/api/cron/complete/${item.id}`)
        this.loadingComponent.close()
        await this.getCronList()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
